<div class="container-fluid position-relative process_homepage_container d-flex flex-column h-100">
  <div class="row mb-1 mb-lg-3 sticky-top">
    <div class="col-sm-12 col-xl-10 offset-xl-1">
      <div class="h-100 p-4 p-lg-5 text-white br-24">
        <h5>{{ 'PROCESSES.HOUSING_CERTIFICATE.START.TITLE' | translate }}</h5>
        <div>{{ 'PROCESSES.HOUSING_CERTIFICATE.START.SUBTITLE' | translate }}</div>
      </div>
    </div>
  </div>


  <div class="row flex-lg-grow-1">
    <div class="col-sm-12 col-lg-6 col-xl-5 offset-xl-1 px-4 mb-3 mb-lg-0 d-flex flex-column" [ngClass]="{'pt-4': isMobile}">

      <div class="d-flex flex-row mt-3 gap-24" *ngFor="let item of [1,2,3,4,5]; let last = last" [ngClass]="{'mb-3': last}">
        <div class="dot grad-orange rounded-circle flex-shrink-0 mt-1"></div>

        <div>
          <h5 class="font-18 txt-darkGray fw-bold">{{ 'PROCESSES.HOUSING_CERTIFICATE.START.LIST.TITLE_' + item | translate}}</h5>
          <p class="font-16 mediumGray fw-normal">{{ 'PROCESSES.HOUSING_CERTIFICATE.START.LIST.TEXT_' + item | translate}}</p>
        </div>
      </div>
      <div class="position-sticky mt-auto bg-white pb-3 pb-lg-0">
        <button class="btn btn-primary w-100 fw-bold" (click)="goNext()" [ngClass]="isMobile ? 'py-4 font-24' : 'py-3'">
          <span class="material-icons-outlined me-1 va-sub" [ngClass]="isMobile ? 'font-24' : 'font-20'">sticky_note_2</span>
          {{ 'PROCESSES.HOUSING_CERTIFICATE.GO_TO_FORM' | translate }}
        </button>
      </div>
    </div>

    <div class="col-sm-12 col-lg-5 offset-lg-1 col-xl-4 pt-1 pt-lg-3 sticky-top order-first order-lg-2">
      <div class="d-flex flex-column h-100 ">
        <h6 class="mediumGray fw-bold">{{ 'COMMON.SATISFIED_OR_REFUND' | translate }}</h6>
        <p class="">{{ 'PROCESSES.HOUSING_CERTIFICATE.RIGHT_BOX_TEXT_2' | translate }}</p>

        <div class="lf-primary-bg br-16 py-3 px-4 overflow-hidden mt-2 mt-auto txt-darkGray d-none d-lg-block" >
          <h5 class="lf-font fw-bold mb-3 font-18">
            <span class="material-icons-outlined me-1 fw-bold v-middle">help</span>
            {{ 'PROCESSES.HOUSING_CERTIFICATE.RIGHT_BOX_TEXT_3' | translate }}
          </h5>
          <p class="fw-normal">{{ 'PROCESSES.HOUSING_CERTIFICATE.RIGHT_BOX_TEXT_4' | translate }}</p>
        </div>
        <button class="btn btn-black-border txt-darkGray bg-white fw-bold py-3 mt-4 d-none d-lg-block" (click)="goTo()">
          <span class="material-icons v-middle">contact_support</span>
          {{ 'COMMON.LEARN_MORE' | translate }}
        </button>
      </div>
    </div>
  </div>
</div>
